// Toasts the host cannot show. A Chatwoot-based CRM has no toast for dashboard apps, so the bridge
// hands `toast` actions here and <HostToastRelay> (inside the ToastProvider) shows them in the app.

import type { HostAction } from '@waforms/app-sdk/client';
import { useToast } from '@waforms/ui';
import { useEffect } from 'react';

type Show = (message: string) => void;

let show: Show | null = null;
const pending: string[] = [];

/** `onUnsupportedAction` for the Chatwoot bridge. */
export function handleUnsupportedAction(action: HostAction): void {
  if (action.type !== 'w3send-app:toast') return;
  if (show) show(action.message);
  else pending.push(action.message);
}

export function HostToastRelay() {
  const { toast } = useToast();
  useEffect(() => {
    show = (message) => toast({ title: message, tone: 'success' });
    for (const message of pending.splice(0)) show(message);
    return () => {
      show = null;
    };
  }, [toast]);
  return null;
}
